module.exports = __webpack_public_path__ + "media/images/Download Centre/Thumbnails/Picture19-b22744f0ed38e838cda0e003ec6a7c23.jpg";